import { useState } from "react";
import { toast } from "sonner";
import { Link2, Loader2, Trophy, Unlink } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AthleteLinkCard = ({ compact = false }) => {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user) return null;

  const start = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sport/link/start");
      window.location.assign(data.authorize_url);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start Talanta Sport linking");
      setBusy(false);
    }
  };

  const unlink = async () => {
    setBusy(true);
    try {
      const { data } = await api.delete("/sport/link");
      setUser(data);
      toast.success("Talanta Sport account unlinked");
    } catch {
      toast.error("Could not unlink");
    } finally {
      setBusy(false);
    }
  };

  const a = user.linked_athlete;
  if (a) {
    return (
      <div data-testid="linked-athlete-card" className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-3.5 flex items-center gap-3">
        <div className="h-10 w-10 rounded-lg bg-talanta-green text-white flex items-center justify-center shrink-0">
          <Trophy className="h-5 w-5 text-talanta-gold" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] uppercase tracking-wider text-emerald-700 font-semibold">Talanta Sport athlete · linked</div>
          <div className="font-semibold text-talanta-charcoal text-sm truncate">{a.name} <span className="font-mono text-xs text-talanta-charcoal/50">{a.id}</span></div>
          <div className="text-xs text-talanta-charcoal/50">{a.sport} · {a.discipline} · {a.county}</div>
        </div>
        {!compact && (
          <button data-testid="unlink-athlete-btn" onClick={unlink} disabled={busy} className="text-xs text-talanta-red hover:underline flex items-center gap-1">
            <Unlink className="h-3.5 w-3.5" /> Unlink
          </button>
        )}
      </div>
    );
  }

  return (
    <button
      data-testid="link-athlete-btn"
      onClick={start}
      disabled={busy}
      className="w-full rounded-xl border border-dashed border-talanta-green/30 bg-talanta-cream hover:bg-talanta-green/5 p-3.5 text-left flex items-center gap-3 transition-colors disabled:opacity-60"
    >
      <div className="h-10 w-10 rounded-lg bg-talanta-green/10 text-talanta-green flex items-center justify-center shrink-0">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Link2 className="h-5 w-5" />}
      </div>
      <div>
        <div className="font-semibold text-talanta-green text-sm">Already a Talanta Sport athlete?</div>
        <div className="text-xs text-talanta-charcoal/55">Sign in with NextGen to link your athlete profile to this ID.</div>
      </div>
    </button>
  );
};
